import {Component} from 'react';
import {withRouter} from "../../hoc/withRouter";
import {Breadcrumb, Col, Row, Input, Button, Form, Divider, Upload, Modal, Alert, Select, Space} from "antd";
import FooterSection from "../../component/pageSection/FooterSection";
import PageHeader from "../../component/header/PageHeader";
import VehicleBrandSelect from "../../component/vehicle/VehicleBrandSelect";
import VehicleModelSelect from "../../component/vehicle/VehicleModelSelect";
import {appDefaultArea} from "../../config/appDataConfig/appConfig";
import Cookies from "universal-cookie";
import {appName} from "../../config/appDataConfig/appConfig";
import UploadOutlined from "@ant-design/icons/UploadOutlined";
import {baseUrlCdnUpload} from "../../config/apiConfig/apiConfig";
import "./formEvTaxi.css";
import {bqBridgingService} from "../../services/BqBridging/BqBridgingService";

const { Option } = Select;

// Daftar huruf depan plat nomor umum di Indonesia
const LICENSE_PLATE_PREFIXES = [
    "A", "B", "D", "E", "F", "G", "H", "K", "L", "M",
    "N", "P", "R", "AB", "AD", "AE", "AG", "DA", "DB", "DC",
    "DD", "DE", "DG", "DH", "DK", "DL", "DM", "DN", "DR", "DT",
    "EA", "EB", "ED", "Z"
  ];

// Tahun kendaraan, membatasi dari 2010 sampai tahun sekarang
const VEHICLE_YEARS = Array.from(
    { length: new Date().getFullYear() - 2010 + 1 }, 
    (_, i) => (new Date().getFullYear() - i).toString()
);

class FormEvMobil extends Component<any, any> {
    private cookies = new Cookies();
    private readonly initState!: any;
    private locationCheckInterval: any;

    constructor(props: any) {
        super(props);

        if (!this.cookies.get('_amc-a')) {
            this.cookies.set('_amc-a', appDefaultArea);
        }

        this.initState = {
            isDesktop: false,
            areaCode: (this.cookies.get('_amc-a')) ? this.cookies.get('_amc-a') : appDefaultArea,
            lat: this.cookies.get('_lat') || "",
            lng: this.cookies.get('_lng') || "",
            
            // Form fields
            category: "car", // Fixed category for vehicle
            brandUuid: "",
            brandName: "",
            modelUuid: "",
            modelName: "",
            vehicleYear: null,
            licensePlatePrefix: null,
            licensePlateNumber: "",
            ownerName: "",
            ownerWhatsapp: "",
            
            // Upload fields
            stnkUrl: "",
            vehiclePhotoUrl: "",
            
            // Upload states
            isUploadingStnk: false,
            isUploadingVehiclePhoto: false,
            isSubmitting: false
        }
        this.state = {...this.initState}
    }

    handleResize = () => {
        if (window.innerWidth < 992) {
            this.setState({
                isDesktop: false,
            });
        } else {
            this.setState({
                isDesktop: true,
            });
        }
    }

    onAreaChange = async (data: any) => {
        this.cookies.set('_amc-a', data.city_group);
        await this.promisedSetState({
            areaCode: data.city_group,
        });
    }

    componentDidMount() {
        setTimeout(() => {
            window.scrollTo({top: 0, behavior: 'smooth'});
        }, 10);

        window.addEventListener("resize", this.handleResize.bind(this));
        this.handleResize();
        
        // Inisialisasi tracking lokasi
        this.initLocationTracking();
        this.locationCheckInterval = setInterval(this.checkLocation, 1000);
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.handleResize.bind(this));
        if (this.locationCheckInterval) {
            clearInterval(this.locationCheckInterval);
        }
    }
    
    initLocationTracking = () => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    const lat = position.coords.latitude;
                    const lng = position.coords.longitude;
                    this.cookies.set('_lat', lat);
                    this.cookies.set('_lng', lng);
                    this.setState({ lat, lng });
                },
                (error) => {
                    console.error("Error obtaining location: ", error);
                }
            );
        } else {
            console.error("Geolocation is not supported by this browser.");
        }
    }
    
    checkLocation = () => {
        const lat = this.cookies.get('_lat');
        const lng = this.cookies.get('_lng');
        if (lat && lng && !this.state.lat) {
            this.setState({ lat, lng });
        }
    }

    componentDidUpdate() {
        // Tambahkan styling untuk select setiap kali komponen update
        const selectElements = document.querySelectorAll('.select-container .ant-select');
        selectElements.forEach((element: any) => {
            if (element) {
                element.style.width = '100%';
            }
        });
    }

    promisedSetState = (newState: any) => new Promise((resolve: any) => this.setState(newState, resolve));

    onVehicleBrandChange = (option: any) => {
        this.setState({
            brandUuid: option.value,
            brandName: option.children,
            // Reset model when brand changes
            modelUuid: "",
            modelName: ""
        });
    }

    onVehicleModelChange = (option: any) => {
        this.setState({
            modelUuid: option.value,
            modelName: option.children
        });
    }

    onFieldChange = (field: string, value: any) => {
        const currentState: any = {...this.state}
        
        switch (field) {
            case "vehicleYear":
                currentState.vehicleYear = value
                break
            case "licensePlatePrefix":
                currentState.licensePlatePrefix = value
                break
            case "licensePlateNumber":
                // Menerima semua huruf (A-Z, a-z), angka, dan spasi
                value = value.replace(/[^A-Za-z0-9\s]/g, '').toUpperCase()
                currentState.licensePlateNumber = value
                break
            case "ownerName":
                currentState.ownerName = value
                break
            case "ownerWhatsapp":
                // Hanya menerima angka
                value = value.replace(/[^0-9]/g, '')
                // Validasi format 08xx
                if (value.length >= 2 && value.substring(0, 2) !== '08') {
                    value = value.substring(0, 1)
                }
                // Batasi panjang nomor
                if (value.length > 13) {
                    value = value.substring(0, 13)
                }
                currentState.ownerWhatsapp = value
                break
        }

        this.setState({
            ...currentState,
        })
    }

    uploadStnkChange = (data: any) => {
        console.log("Upload STNK event:", data);
        
        if (data?.file?.status === "done") {
            console.log("Upload response:", data?.file?.response);
            
            // Cek berbagai kemungkinan struktur response
            let newDocUrl;
            if (data?.file?.response?.data?.url_document) {
                newDocUrl = data?.file?.response?.data?.url_document;
            } else if (data?.file?.response?.data?.Location) {
                newDocUrl = data?.file?.response?.data?.Location;
            } else if (typeof data?.file?.response?.data === 'string') {
                newDocUrl = data?.file?.response?.data;
            }
            
            this.setState({
                stnkUrl: newDocUrl || "",
                isUploadingStnk: false
            });
        }
        if (data?.file?.status === "uploading") {
            this.setState({
                isUploadingStnk: true
            });
        }
        if (data?.file?.status === "removed") {
            this.setState({
                stnkUrl: "",
                isUploadingStnk: false
            });
        }
        if (data?.file?.status === "error") {
            console.error("Upload error:", data?.file?.error);
            Modal.error({
                title: 'Upload Gagal',
                content: 'Terjadi kesalahan saat mengupload gambar STNK.'
            });
            this.setState({
                isUploadingStnk: false
            });
        }
    }

    uploadVehiclePhotoChange = (data: any) => {
        console.log("Upload Vehicle Photo event:", data);
        
        if (data?.file?.status === "done") {
            console.log("Upload response:", data?.file?.response);
            
            // Cek berbagai kemungkinan struktur response
            let newDocUrl;
            if (data?.file?.response?.data?.url_document) {
                newDocUrl = data?.file?.response?.data?.url_document;
            } else if (data?.file?.response?.data?.Location) {
                newDocUrl = data?.file?.response?.data?.Location;
            } else if (typeof data?.file?.response?.data === 'string') {
                newDocUrl = data?.file?.response?.data;
            }
            
            this.setState({
                vehiclePhotoUrl: newDocUrl || "",
                isUploadingVehiclePhoto: false
            });
        }
        if (data?.file?.status === "uploading") {
            this.setState({
                isUploadingVehiclePhoto: true
            });
        }
        if (data?.file?.status === "removed") {
            this.setState({
                vehiclePhotoUrl: "",
                isUploadingVehiclePhoto: false
            });
        }
        if (data?.file?.status === "error") {
            console.error("Upload error:", data?.file?.error);
            Modal.error({
                title: 'Upload Gagal',
                content: 'Terjadi kesalahan saat mengupload foto kendaraan.'
            });
            this.setState({
                isUploadingVehiclePhoto: false
            });
        }
    }

    validateForm = () => {
        let isValid = true;
        let errorMessage = "";

        if (!this.state.brandUuid) {
            isValid = false;
            errorMessage += "Merk kendaraan, ";
        }
        if (!this.state.modelUuid) {
            isValid = false;
            errorMessage += "Model kendaraan, ";
        }
        if (!this.state.vehicleYear) {
            isValid = false;
            errorMessage += "Tahun kendaraan, ";
        }
        if (!this.state.licensePlatePrefix) {
            isValid = false;
            errorMessage += "Kode plat nomor, ";
        }
        if (!this.state.licensePlateNumber) {
            isValid = false;
            errorMessage += "Nomor plat kendaraan, ";
        }
        if (!this.state.ownerName) {
            isValid = false;
            errorMessage += "Nama pemilik, ";
        }
        if (!this.state.ownerWhatsapp || this.state.ownerWhatsapp.length < 10) {
            isValid = false;
            errorMessage += "Nomor WhatsApp pemilik (minimal 10 digit), ";
        }
        if (!this.state.stnkUrl) {
            isValid = false;
            errorMessage += "Foto STNK, ";
        }
        if (!this.state.vehiclePhotoUrl) {
            isValid = false;
            errorMessage += "Foto kendaraan, ";
        }
        if (!this.state.lat || !this.state.lng) {
            isValid = false;
            errorMessage += "mohon izinkan allow location pada browser, ";
        }

        return { isValid, errorMessage };
    }

    onSubmitForm = async () => {
        const { isValid, errorMessage } = this.validateForm();
        
        if (!isValid) {
            Modal.error({
                title: 'Proses Gagal',
                content: (<div>
                    Mohon Lengkapi data-data berikut: <br/><br/>
                    {errorMessage.split(",").map(function (itemError, i) {
                        return itemError ? <div key={i}>{itemError}</div> : null;
                    })}
                </div>)
            });
            return;
        }

        // Prepare data object dengan format yang diminta
        const fullLicensePlate = `${this.state.licensePlatePrefix} ${this.state.licensePlateNumber}`;
        
        const formData = {
            category: this.state.category,
            brand_uuid: this.state.brandUuid,
            brand_name: this.state.brandName?.toUpperCase(),
            model_uuid: this.state.modelUuid,
            model_name: this.state.modelName?.toUpperCase(),
            vehicle_year: parseInt(this.state.vehicleYear),
            license_plate: fullLicensePlate,
            owner_name: this.state.ownerName?.toUpperCase(),
            owner_whatsapp: this.state.ownerWhatsapp,
            vehicle_registration_url: this.state.stnkUrl,
            vehicle_photo_url: this.state.vehiclePhotoUrl,
            location: {
                latitude: parseFloat(this.state.lat),
                longitude: parseFloat(this.state.lng)
            }
        };

        // Set loading state
        this.setState({ isSubmitting: true });

        try {
            // Kirim data ke BqBridging menggunakan storeDataVehicle
            await bqBridgingService.storeDataVehicle(formData);
            
            // Reset form ke state awal
            this.setState({
                ...this.initState,
                areaCode: this.state.areaCode, // Pertahankan areaCode
                lat: this.state.lat, // Pertahankan lat
                lng: this.state.lng, // Pertahankan lng
                isDesktop: this.state.isDesktop // Pertahankan isDesktop
            });

            // Tampilkan modal sukses
            Modal.success({
                title: 'Terima Kasih',
                content: (
                    <div>
                        <p>Data kendaraan Anda telah berhasil disimpan.</p>
                        <p>Tim kami akan segera menghubungi Anda melalui WhatsApp untuk proses selanjutnya.</p>
                    </div>
                ),
                okText: 'Tutup',
                onOk: () => {
                    // Scroll ke atas halaman
                    window.scrollTo({top: 0, behavior: 'smooth'});
                }
            });

        } catch (error) {
            // Tampilkan error jika gagal
            Modal.error({
                title: 'Gagal Menyimpan Data',
                content: 'Terjadi kesalahan saat menyimpan data. Silakan coba lagi.'
            });
            console.error('Error submitting form:', error);
        } finally {
            // Reset loading state
            this.setState({ isSubmitting: false });
        }
    }

    render() {
        // Custom styles
        const formItemStyle = {
            marginBottom: '15px'
        };

        const inputStyle = {
            height: '40px',
            width: '100%'
        };

        const selectStyle = {
            height: '40px',
            width: '100%'
        };

        return (
            <>
                <PageHeader black={true} onAreaChangeProps={this.onAreaChange} areaCode={this.state.areaCode} isDesktop={this.state.isDesktop}/>

                <Row className={`pt-100`}>
                    <Col xxl={{span: 16, offset: 4}} xl={{span: 16, offset: 4}} lg={{span: 20, offset: 2}} md={{span: 20, offset: 2}} sm={{span: 24}} xs={{span: 24}}>
                        <Breadcrumb className={`pl-20`}>
                            <Breadcrumb.Item>Amarta {appName}</Breadcrumb.Item>
                            <Breadcrumb.Item>Form Pendaftaran Kendaraan Taksi Listrik</Breadcrumb.Item>
                        </Breadcrumb>
                    </Col>
                </Row>

                <Row className={`p-20 mt-20`} style={{backgroundColor: "#fff"}}>
                    <Col xxl={{span: 16, offset: 4}} xl={{span: 16, offset: 4}} lg={{span: 20, offset: 2}} md={{span: 20, offset: 2}} sm={{span: 24}} xs={{span: 24}}>
                        <div>
                            <div style={{textAlign: "center", fontSize: "170%", marginBottom: 7}}>Pendaftaran Kendaraan Taksi Listrik</div>
                            <div style={{textAlign: "center", fontSize: "100%", marginBottom: 20, color: "gray"}}>Silakan isi data kendaraan Anda pada form di bawah ini</div>
                        </div>
                        
                        <Alert
                            message="Allow Access Location"
                            description={(this.state.lat && this.state.lng) ? 'Location Ok, silakan lanjut pengisian data' : 'Sebelum melakukan pengisian mohon izinkan Allow Location Permission pada browser.'}
                            type="info"
                            showIcon
                            style={{marginBottom: 20}}
                        />

                        <Form layout="vertical" className="ev-taxi-form">
                            <Row>
                                <Col xl={{span: 12}} xs={{span: 24}} style={{paddingLeft: 5, paddingRight: 5}}>
                                    <Form.Item style={formItemStyle}>
                                        <i className={`text-small-grey-nopadding`}>Merk Kendaraan *</i>
                                        <VehicleBrandSelect
                                            category={this.state.category}
                                            onVehicleBrandChangeProps={this.onVehicleBrandChange}
                                            value={this.state.brandUuid}
                                        />
                                    </Form.Item>
                                </Col>
                                <Col xl={{span: 12}} xs={{span: 24}} style={{paddingLeft: 5, paddingRight: 5}}>
                                    <Form.Item style={formItemStyle}>
                                        <i className={`text-small-grey-nopadding`}>Model Kendaraan *</i>
                                        <VehicleModelSelect
                                            category={this.state.category}
                                            brandCode={this.state.brandUuid}
                                            onVehicleModelChangeProps={this.onVehicleModelChange}
                                            value={this.state.modelUuid}
                                        />
                                    </Form.Item>
                                </Col>
                            </Row>

                            <Row>
                                <Col xl={{span: 12}} xs={{span: 24}} style={{paddingLeft: 5, paddingRight: 5}}>
                                    <Form.Item style={formItemStyle}>
                                        <i className={`text-small-grey-nopadding`}>Tahun Kendaraan *</i>
                                        <Select
                                            placeholder="Pilih tahun kendaraan"
                                            style={selectStyle}
                                            value={this.state.vehicleYear}
                                            onChange={value => this.onFieldChange("vehicleYear", value)}
                                        >
                                            {VEHICLE_YEARS.map(year => (
                                                <Option key={year} value={year}>{year}</Option>
                                            ))}
                                        </Select>
                                    </Form.Item>
                                </Col>
                                <Col xl={{span: 12}} xs={{span: 24}} style={{paddingLeft: 5, paddingRight: 5}}>
                                    <Form.Item style={formItemStyle}>
                                        <i className={`text-small-grey-nopadding`}>Plat Nomor Kendaraan *</i>
                                        <Space style={{width: '100%'}}>
                                            <Select
                                                placeholder="Kode"
                                                style={{width: 100, height: '40px'}}
                                                value={this.state.licensePlatePrefix}
                                                onChange={value => this.onFieldChange("licensePlatePrefix", value)}
                                                showSearch
                                                filterOption={(input, option) =>
                                                    option && option.children ? option.children.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0 : false
                                                }
                                                optionFilterProp="children"
                                            >
                                                {LICENSE_PLATE_PREFIXES.map(prefix => (
                                                    <Option key={prefix} value={prefix}>{prefix}</Option>
                                                ))}
                                            </Select>
                                            <Input 
                                                value={this.state.licensePlateNumber} 
                                                onChange={event => this.onFieldChange("licensePlateNumber", event.target.value)} 
                                                placeholder="1234 AB"
                                                style={{width: '100%', height: '40px'}}
                                            />
                                        </Space>
                                    </Form.Item>
                                </Col>
                            </Row>

                            <Row>
                                <Col xl={{span: 12}} xs={{span: 24}} style={{paddingLeft: 5, paddingRight: 5}}>
                                    <Form.Item style={formItemStyle}>
                                        <i className={`text-small-grey-nopadding`}>Nama Pemilik *</i>
                                        <Input 
                                            value={this.state.ownerName} 
                                            onChange={event => this.onFieldChange("ownerName", event.target.value)} 
                                            placeholder="Masukan Nama Pemilik"
                                            style={inputStyle}
                                        />
                                    </Form.Item>
                                </Col>
                                <Col xl={{span: 12}} xs={{span: 24}} style={{paddingLeft: 5, paddingRight: 5}}>
                                    <Form.Item style={formItemStyle}>
                                        <i className={`text-small-grey-nopadding`}>No. WhatsApp Pemilik *</i>
                                        <Input
                                            value={this.state.ownerWhatsapp}
                                            maxLength={17}
                                            placeholder="Format: 08xxxxxxxx"
                                            onChange={event => this.onFieldChange("ownerWhatsapp", event.target.value)}
                                            style={inputStyle}
                                        />
                                    </Form.Item>
                                </Col>
                            </Row>

                            <Divider orientation="left" plain>
                                <span style={{fontSize: '16px', color: '#384967', fontWeight: 500}}>Dokumen Kendaraan</span>
                            </Divider>
                            
                            <Row>
                                <Col xl={{span: 12}} xs={{span: 24}} style={{paddingLeft: 5, paddingRight: 5, marginBottom: 20}}>
                                    <Form.Item style={formItemStyle}>
                                        <i className={`small-text-grey`}>Upload Foto STNK *</i><br/>
                                        <Upload
                                            method="POST"
                                            action={baseUrlCdnUpload + "/upload-document/document-data"}
                                            maxCount={1}
                                            data={{
                                                document_name: (Math.random() + 1).toString(36).substring(7),
                                                company: "amarta",
                                                document_type: "stnk",
                                            }}
                                            name="image"
                                            onChange={this.uploadStnkChange}
                                            style={{width: '100%'}}
                                            listType="picture"
                                        >
                                            <Button icon={<UploadOutlined/>} loading={this.state.isUploadingStnk}>
                                                Upload Foto STNK
                                            </Button>
                                        </Upload>
                                        
                                        {this.state.stnkUrl ? (
                                            <div style={{marginTop: 10}}>
                                                <div style={{color: 'green', marginBottom: 5}}>✓ Foto STNK berhasil diunggah</div>
                                                <img src={this.state.stnkUrl} alt="Foto STNK" style={{maxWidth: '100%', maxHeight: '200px'}} />
                                            </div>
                                        ) : null}
                                    </Form.Item>
                                </Col>
                                
                                <Col xl={{span: 12}} xs={{span: 24}} style={{paddingLeft: 5, paddingRight: 5, marginBottom: 20}}>
                                    <Form.Item style={formItemStyle}>
                                        <i className={`small-text-grey`}>Upload Foto Kendaraan *</i><br/>
                                        <Upload
                                            method="POST"
                                            action={baseUrlCdnUpload + "/upload-document/document-data"}
                                            maxCount={1}
                                            data={{
                                                document_name: (Math.random() + 1).toString(36).substring(7),
                                                company: "amarta",
                                                document_type: "vehicle_photo",
                                            }}
                                            name="image"
                                            onChange={this.uploadVehiclePhotoChange}
                                            style={{width: '100%'}}
                                            listType="picture"
                                        >
                                            <Button icon={<UploadOutlined/>} loading={this.state.isUploadingVehiclePhoto}>
                                                Upload Foto Kendaraan
                                            </Button>
                                        </Upload>
                                        
                                        {this.state.vehiclePhotoUrl ? (
                                            <div style={{marginTop: 10}}>
                                                <div style={{color: 'green', marginBottom: 5}}>✓ Foto kendaraan berhasil diunggah</div>
                                                <img src={this.state.vehiclePhotoUrl} alt="Foto Kendaraan" style={{maxWidth: '100%', maxHeight: '200px'}} />
                                            </div>
                                        ) : null}
                                    </Form.Item>
                                </Col>
                            </Row>

                            <Divider />
                            
                            <Button 
                                onClick={this.onSubmitForm} 
                                loading={this.state.isSubmitting} 
                                style={{backgroundColor: '#384967', width: "160px", borderColor: '#384967', color: '#fff'}} 
                                danger
                                disabled={!this.state.lat || !this.state.lng}
                            >
                                Simpan Form
                            </Button>
                            {(!this.state.lat || !this.state.lng) && (
                                <span style={{marginLeft: '10px', color: '#ff4d4f', fontSize: '12px'}}>
                                    Mohon izinkan akses lokasi terlebih dahulu
                                </span>
                            )}
                        </Form>
                    </Col>
                </Row>

                <div style={{minHeight: 100}}/>
                <FooterSection/>
            </>
        );
    }
}

export default withRouter(FormEvMobil); 